angular.module('assets')
    .component('assetAcquisition', {
        bindings: {
            acquisition: '<?'
        },
        template: `
            <span ng-if="$ctrl.acquisition">{{ 'asset.acquisition.'.concat($ctrl.acquisition) | translate}}</span>
        `
    })
